import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { PricingPlan } from 'src/features/pricingPlans/types';

const RESOURCE = '/parkings/:parkingId/pricing-plans/normal/:planId';

interface DTO {
    parkingId: string;
    planId: number;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ planId, parkingId }: DTO): Promise<PricingPlan> => {
    return axios.delete(formatResourcePath(RESOURCE, { planId, parkingId }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as DELETE_PRICING_PLAN_RESOURCE, useMutationHook as useDeletePricingPlan };
export type { DTO as DeletePricingPlanDTO };
